<form [formGroup]="form">
    <app-medical-fee-amount #medicalFeeAmount formControlName="MedicalFeeAmount"></app-medical-fee-amount>
</form>